import React, { Component } from 'react';
import axios from 'axios';
import Datetime from "react-datetime";
import Container from 'react-bootstrap/Container';
import {Row, Col, Form} from 'react-bootstrap';
import { validate as validateEmail } from 'email-validator';
import moment from 'moment';
import $ from "jquery";

import Axios from './utils/Axios';

import "react-datetime/css/react-datetime.css";
import "./style.css";

let day_labels = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var yesterday = moment().subtract( 1, 'day' );
var valid_date = function( current ){
    return current.isAfter( yesterday ) && ((current.day() !== 0) && (current.day() !== 6));
};

function uuidv4()
{
    var d = new Date().getTime();//Timestamp
    var d2 = ((typeof performance !== 'undefined') && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

function parseISOString(s) {
  var b = s.split(/\D+/);
  return new Date(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]);
}

function date_to_utc(date)
{
  const utc_timestamp = Date.UTC(date.getUTCFullYear(), date.getUTCMonth(),
                  date.getUTCDate(), date.getUTCHours(),
                  date.getUTCMinutes(), date.getUTCSeconds());
  return new Date(utc_timestamp);
}


class GoogleCalendarAppointmentPicker extends Component
{
  constructor(props)
  {
    super(props);

    this.state = 
    {
      ...this.state,
      leadlazarus_api_data: props.leadlazarus_api_data,
      confirmed_time: false,
      events: props.events,
      context: "Lead Lazarus  - Appointment",
      mounted: false,
      have_connection: false,
      valid_params: true
    };

    this.get_free_slots = this.get_free_slots.bind(this);
    this.get_events = this.get_events.bind(this);
    this.find_day = this.find_day.bind(this);
    this.find_event_on_day = this.find_event_on_day.bind(this);
    this.find_events_on_day = this.find_events_on_day.bind(this);

    this.on_firstname_change = this.on_firstname_change.bind(this);
    this.on_cellphone_change = this.on_cellphone_change.bind(this);
    this.on_email_change = this.on_email_change.bind(this);
    this.on_commit = this.on_commit.bind(this);
    this.handle_click = this.handle_click.bind(this);
    this.scroll_to_top = this.scroll_to_top.bind(this);

    this.validate_param = this.validate_param.bind(this);
    this.validate_params = this.validate_params.bind(this);
    
    this.render_on_commit_warning = this.render_on_commit_warning.bind(this);
    this.render_time = this.render_time.bind(this);
    this.render_times = this.render_times.bind(this);
    this.render_button = this.render_button.bind(this);
    this.render_selected_time = this.render_selected_time.bind(this);
    this.render_day = this.render_day.bind(this);
    this.render_month = this.render_month.bind(this);
    this.render_confirmation = this.render_confirmation.bind(this);
    this.render_appointment_booker = this.render_appointment_booker.bind(this);

    this.render_google_calendar_connect_button = this.render_google_calendar_connect_button.bind(this);
    this.render_calendar = this.render_calendar.bind(this);

    this.top_ref = React.createRef();
    this.time_selector_ref = React.createRef();
    this.confirmation_ref = React.createRef();
  }

  async componentDidMount()
  {
    const _this = this;

    const api_key = _this.state.leadlazarus_api_data.leadlazarus_api_key;

    const ll_lead_created_calendar_events = this.state.leadlazarus_api_data.ll_lead_created_calendar_events;
    const ll_email_notification = this.state.leadlazarus_api_data.ll_email_notification;

    console.log("ll_lead_created_calendar_events: ", ll_lead_created_calendar_events);
    console.log("ll_email_notification: ", ll_email_notification);

    await Axios.Get('/api/client_by_api_key', null, api_key, async(response)=> 
    {
      const client = response.data;
      if(client != null)
      {
        console.log("client: ", client);
        if( ((client.notification_email != ll_email_notification) || 
             (client.lead_created_calendar_events != ll_lead_created_calendar_events)) && 

           (ll_email_notification != null) &&
           (ll_email_notification.length > 0) &&
           (ll_email_notification.indexOf('@') != -1) &&
           (ll_email_notification.indexOf('.') != -1) )
        {
          const client_settings_data =
          {
            notification_email: ll_email_notification,
            lead_created_calendar_events: (ll_lead_created_calendar_events) ? true : false
          }

          await Axios.Post('/api/update_client_settings', client_settings_data, api_key, async(response)=> 
          {
            console.log("update_client_settings - response: ", response);
          });
        }
      }
    });

    // Send the current URL to your Node.js server to handle OAuth
    await Axios.Get('/has_connection', null, api_key, async(response)=> 
    {
      if(response.data != null)
      {
        await _this.setState({..._this.state, mounted: true, have_connection: response.data.have_connection}, 
        async ()=>
        {
          if(_this.state.have_connection)
          {
            await _this.get_events(api_key);
          }
          else
          if(response.data.authUrl != null)
          {
            await _this.setState({..._this.state, mounted: false, have_connection: false});
            window.location.href = response.data.authUrl;
          }
        });
      }
    },
    (error)=>
    {
      // Handle error if the GET request fails
      console.error('has_connection - Error connecting to the server:', error);
    });
  }

  days_in_month(date)
  {
    return new Date(date.getFullYear(), date.getMonth()+1, 0).getDate();
  }

  async get_events(api_key)
  {
    const _this = this;

    await Axios.Get('/get_events/', null, api_key, async(response)=>
    {
        if(response.data != null)
        {
          var events = [];
          for(var i=0; i < response.data.length; ++i)
          {
            const event_data = response.data[i];

            const start_date_time = (event_data.start.dateTime != null) ? event_data.start.dateTime : event_data.start.date;
            const end_date_time = (event_data.end.dateTime != null) ? event_data.end.dateTime : event_data.end.date;

            if((start_date_time != null) && (end_date_time != null))
            {
              var event =
              {
                  start: parseISOString(start_date_time),
                  end: parseISOString(end_date_time),
                  creator: event_data.creator,
                  summary: event_data.summary
              }

              // We're only interested in hours and minutes.
              // This is necessary since Google AppointmentBooker may have set
              // some value in the milliseconds and the timestamp comparisons
              // will fail later if we're not careful.
              event.start.setSeconds(0);
              event.start.setMilliseconds(0);
              event.end.setSeconds(0);
              event.end.setMilliseconds(0);
              events.push(event);
            }
          }

          await _this.setState({..._this.state, events});
          // console.log("events: ", events);

          await _this.get_free_slots(20, 30);
        }
    });
  }

  get_free_slots(num_slots_per_day, slot_length_minutes)
  {
    const _this = this;

    const events = _this.state.events;
    if(events != null)
    {
      var date = new Date();
      var time = new Date();

      var days = [];
      const days_in_month = _this.days_in_month(new Date());
      for(var i=date.getDate(); i <= days_in_month; ++i)
      {
        time.setDate(date.getDate());
        time.setHours(9);
        time.setMinutes(0);
        time.setSeconds(0);
        time.setMilliseconds(0);

        var num_free_slots = 0;
        for(var j=0; j < num_slots_per_day; ++j)
        {
          const day = time.getDate();
          if(_this.is_slot_available(time, events))
          {
            ++num_free_slots;
          }

          time.setMinutes(time.getMinutes() + slot_length_minutes);
        }

        const day_info =
        {
          day: new Date(date),
          num_free_slots
        };

        days.push(day_info);
        _this.setState({..._this.state, days});
        date.setDate(date.getDate() + 1);
      }
    }
  }

  find_day(day_date, month)
  {
    const _this = this;

    const days = _this.state.days;
    if(days != null)
    {
      for(var i=0; i < days.length; ++i)
      {
        const day_info = days[i];
        if((day_date == day_info.day.getDate()) && (month == day_info.day.getMonth()))
        {
          return day_info;
        }
      }
    }
    return null;
  }

  find_event_on_day(day, month)
  {
    const _this = this;

    const events = _this.state.events;
    if(events != null)
    {
      for(var i=0; i < events.length; ++i)
      {
        const event = events[i];
        const event_day = event.start.getDate();
        const event_month = event.start.getMonth();

        if((event_day == day ) && (event_month == month))
        {
          return event;
        }
      }
    }
    return null;
  }

  find_events_on_day(day, month)
  {
    const _this = this;

    var events_on_day = [];
    const events = _this.state.events;
    if(events != null)
    {
      for(var i=0; i < events.length; ++i)
      {
        const event = events[i];
        const event_day = event.start.getDate();
        const event_month = event.start.getMonth();

        if((event_day == day ) && (event_month == month))
        {
          events_on_day.push(event);
        }
      }
    }
    return events_on_day;
  }

  is_slot_available(time, events)
  {
    for(var j=0; j < events.length; ++j)
    {
      const event = events[j];
      const timestamp = time.getTime();
      if((timestamp >= event.start.getTime()) && (timestamp < event.end.getTime()))
      {
        return false;
      }
    }
    return true;
  }

  on_firstname_change(e)
  {
    const _this = this;
    _this.setState({..._this.state, name: e.target.value, valid_params: true});
  }

  on_cellphone_change(e)
  {
    const _this = this;
    _this.setState({..._this.state, phone_number: e.target.value, valid_params: true});
  }

  on_email_change(e)
  {
    const _this = this;
    _this.setState({..._this.state, email: e.target.value, valid_params: true});
  }

  validate_email(email)
  {
    if((email != null) && (email.length > 0))
    {
      if((email.indexOf('@') != -1) && (email.indexOf('.') != -1))
      {
        return true;
      }
    }
    return false;
  }

  validate_string_param(param)
  {
    if((param != null) && (param.length > 0))
    {
        return true;
    }
    return false;
  }

  validate_param(param)
  {
    if(param != null)
    {
        return true;
    }
    return false;
  }

  validate_params(on_success)
  {
    const _this = this;

    _this.setState({..._this.state, valid_params: false}, async()=>
    {
      const {selected_day, selected_time, name, email, phone_number} = _this.state;    

      if(_this.validate_param(selected_day) &&
        _this.validate_param(selected_time) &&
        _this.validate_string_param(name) &&
        _this.validate_string_param(phone_number) &&
        _this.validate_email(email))
      {
        _this.setState({..._this.state, valid_params: true}, on_success);
      }
      else
      {
        on_success();
      }
    });
  }

  async on_commit(post_data)
  {
    // console.log("on_commit - post_data: ", post_data);

    const _this = this;

    if(post_data != null)
    {
      _this.validate_params(async()=>
      {
        if(_this.state.valid_params)
        {
          const api_key = _this.state.leadlazarus_api_data.leadlazarus_api_key;
          await Axios.Post('/api/lead_appointment', post_data, api_key, (response)=>
          {
            _this.setState({..._this.state, selected_time: null, confirmed_time: post_data}, async()=>{
              // console.log("SET CONFIRMED TIME - _this.state.confirmed_time: ", _this.state.confirmed_time);
            });
          });
        }
        else
        {
          console.log("INVALID POST PARAMS!!!");
        }
      });
    }


  /*
    const {selected_day, selected_time, email, phone_number} = _this.state;    

    if((post_data != null) &&
       _this.validate_param(selected_day) &&
       _this.validate_param(selected_time) &&
       _this.validate_param(phone_number) &&
       _this.validate_param(email))
    {
      const api_key = _this.state.leadlazarus_api_data.leadlazarus_api_key;
      await Axios.Post('/api/lead_appointment', post_data, api_key, (response)=>
      {
        _this.setState({..._this.state, selected_time: null, confirmed_time: post_data}, async()=>{
          // console.log("SET CONFIRMED TIME - _this.state.confirmed_time: ", _this.state.confirmed_time);
        });
      });
    }
    */
  }

  async handle_click()
  {
    const _this = this;

    const api_key = _this.state.leadlazarus_api_data.leadlazarus_api_key;

    // Get the current page URL from the browser
    const currentUrl = window.location.href;
    
    console.log("currentUrl: ", currentUrl);

    // Send the current URL to your Node.js server to handle OAuth
    await Axios.Post('/auth_google', {client_redirect_url: currentUrl}, api_key,
    (response)=>
    {
      // Handle success if needed
      // console.log('Redirecting to Google OAuth:', response);
      window.location.href = response.data.authUrl;  // Assuming the server returns the OAuth URL
      console.log("currentUrl: ", response.data.authUrl);
    },
    (error)=>
    {
      // Handle error if the GET request fails
      console.error('Error connecting to the server:', error);
    });
  };

  scroll_to_top()
  {
    const _this = this;

    if((_this.state.selected_time != null) && (_this.state.confirmed_time != null))
    {
      // console.log("scroll_to_top");
      window.scrollTo({ behavior: 'smooth', top: this.top_ref.current.offsetTop - 100 })
    }
  }

  
  render_on_commit_warning()
  {
    const _this = this;

    if(!_this.state.valid_params)
    {
      return (<h6 className='commit_warning'>All information is required!</h6>);
    }
  }

  render_time(time, key)
  {
    const _this = this;

    const {leadlazarus_api_data} = _this.state;
    const ll_button_time_color = leadlazarus_api_data.ll_button_time_color;
    // const ll_button_time_outline_color = leadlazarus_api_data.ll_button_time_outline_color;
    const ll_button_corner_radius = leadlazarus_api_data.ll_button_corner_radius;
    const ll_button_general_text_color = leadlazarus_api_data.ll_button_general_text_color;
    
    // return <td key={key} {...ffb} style={{"backgroundColor": ll_button_selected_day_color}} >{date}</td>;

    const style = 
    {
      "background-color": ll_button_time_color, 
      "borderRadius": ll_button_corner_radius + "px",
      "color": ll_button_general_text_color,
      // "border-color": ll_button_time_outline_color,
      // "border-style": "solid",
      // "border-width": "4px"
    };

    return (<Col key={key}
                  className="schedule_time"
                  style={style}
                  onClick={(e)=>
                  {
                    const label = e.target.innerText;
                    var time = e.target.innerText;
                    time = time.replace(" am", "");
                    time = time.replace(" pm", "");
                    const selected_time = {time, label};
                    _this.setState({..._this.state, selected_time});
                  }}>
              <center>
                  {time}
              </center>
            </Col>);
  }

  render_times()
  {
    const _this = this;

    const selected_day = _this.state.selected_day;
    if(selected_day != null)
    {
      var times = [];
      var time = selected_day.date;
      time.setHours(9);
      time.setSeconds(0);
      time.setMilliseconds(0);

      for(var i=0; i < 20; ++i)
      {
        const found_event_on_hour = !_this.is_slot_available(time, selected_day.events);
        if(!found_event_on_hour)
        {
          var hours = time.getHours();
          if(hours > 12)
          {
            hours -= 12;
          }

          var time_str = hours + ":" + time.getMinutes();
          time_str = time_str.replace(":0", "");
          if(time.getHours() >= 12)
          {
              time_str += " pm";
          }
          else
          {
            time_str += " am";
          }
          times.push(time_str);
        }

        time.setMinutes(time.getMinutes() + 30);
      }

      return (
          <Row className="day_times_row">
            <center>
              {times.map((d, i) => _this.render_time(d, i) )}
            </center>
          </Row>
        );
      }
  }

  render_button(label, className, on_click)
  {
    const _this = this;

    const {leadlazarus_api_data} = _this.state;
    const ll_button_general_color = leadlazarus_api_data.ll_button_general_color;
    const ll_button_corner_radius = leadlazarus_api_data.ll_button_corner_radius;
    const ll_button_general_text_color = leadlazarus_api_data.ll_button_general_text_color;
    
    const style = 
    {
      "background-color": ll_button_general_color,
      "borderRadius": ll_button_corner_radius + "px",
      "color": ll_button_general_text_color,
      // "border-color": ll_button_time_outline_color,
      // "border-style": "solid",
      // "border-width": "4px"
    };

    return (
      <div className={className} style={style} onClick={on_click}>
          {label}
       </div>
    );
  }

  render_selected_time()
  {
    const _this = this;

    const {selected_day, selected_time, email, name, phone_number, context} = _this.state;
    if(selected_time != null)
    {
      const confirmed_time = selected_time.time;
      const day_label = day_labels[selected_day.date.getDay()];
      const confirmation_label = selected_time.label + ", " + selected_day.date.toLocaleDateString('en-us', { weekday:"long", year:"numeric", month:"short", day:"numeric"});
      const never_share = "We'll never share your email with anyone else.";
      const isValidEmail = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/g;

      return (
        <React.Fragment>
          <Container className="confirm-time-section">
            <Row>
              <h6><strong> You have selected {confirmation_label}</strong>.</h6>
              <p>Please enter your email address to confirm your appointment.</p>
              {_this.render_on_commit_warning()}
            
              <Form>
                  <Form.Group className="mb-3" controlId="formFirstName">
                   <Form.Label>First Name</Form.Label>
                   <Form.Control type="text" placeholder="Enter First Name" onChange={_this.on_firstname_change}/>
                   <Form.Text className="text-muted">
                   </Form.Text>
                 </Form.Group>
                 <br/>
                 <Form.Group className="mb-3" controlId="form_cellphone">
                   <Form.Label>Cellphone number</Form.Label>
                   <Form.Control type="text" placeholder="Enter your cellphone number" onChange={_this.on_cellphone_change}/>
                   <Form.Text className="text-muted">
                   </Form.Text>
                 </Form.Group>
                 <br/>
                 <Form.Group className="mb-3" controlId="formBasicEmail">
                   <Form.Label>Email address</Form.Label>
                   <Form.Control type="email" placeholder="Enter email address" onChange={_this.on_email_change}/>
                   <Form.Text className="text-muted">
                   <br/>
                    {never_share}
                   </Form.Text>
                 </Form.Group>
              </Form>

            </Row>
            <div className="button-row">
              <span style={{"display": "inline-block !important"}}>
                  {
                    _this.render_button("Back", "times-back-button", ()=>
                    {
                      _this.setState({..._this.state, selected_time: null});
                    })
                  }
                  {
                    _this.render_button("Confirm", "times-confirm-button", ()=>
                    {
                      const post_data =
                      {
                        selected_day, selected_time, email, name, phone_number, context,
                        page_url: window.location.href,
                        timestamp: (new Date()).getTime()
                      }
                      _this.on_commit(post_data);
                    })
                   }
              </span>
           </div>
         </Container>
       </React.Fragment>
      );
    }
  }

  render_day(props, currentDate, selectedDate)
  {
    const _this = this;

    const {leadlazarus_api_data} = _this.state;

    // We have to do this or React will whine that the key
    // is part of the props and the props are being spread
    const ffb = {...props};
    delete ffb.key;

    const classes = ffb.className;
    const is_active = (classes.indexOf("rdtActive") != -1);

    const date = currentDate.date();

    // Stop react from whining about the missing key...
    const key = uuidv4();

    const event = _this.find_event_on_day(currentDate.date(), currentDate.month());
    if(event != null)
    {
      // console.log("FOUND EVENT!");
      // return <td key={key} {...ffb} style={{"backgroundColor": "yellow"}} >{date}</td>;
    }

    const day = _this.find_day(currentDate.date(), currentDate.month());
    if(day != null)
    {
      // Disable selection of days with no free slots
      if(day.num_free_slots == 0)
      {
        return <td key={key} {...ffb} className="rdtDisabled" style={{"backgroundColor": "#eee"}} >{date}</td>;
      }
    }

    // console.log("ffb: ", ffb);

    const ll_button_selected_day_color = leadlazarus_api_data.ll_button_selected_day_color;
    const ll_button_selected_day_outline_color = leadlazarus_api_data.ll_button_selected_day_outline_color;
    const ll_button_corner_radius = leadlazarus_api_data.ll_button_corner_radius;
    const ll_button_general_text_color = leadlazarus_api_data.ll_button_general_text_color;

    if(is_active)
    {
      const active_style = 
      {
        "backgroundColor": ll_button_selected_day_color, 
        "borderRadius": ll_button_corner_radius + "px",
        "color": ll_button_general_text_color,
        // "border-color": ll_button_selected_day_outline_color, 
        // "border-style": "solid",
        // "border-width": "4px",
      }

      return <td key={key} {...ffb} style={active_style} >{date}</td>;
    }
    return <td key={key} {...ffb}>{date}</td>;
  }

  render_month(props, month, year, selectedDate)
  {
    // Display the month index in the months _this
    return <td  {...props}>{month}</td>;
  }

  render_year(props, year, selectedDate) {
    // Just display the last 2 digits of the year in the years _this
    return <td {...props}>{year % 100}</td>;
  }


  render_confirmation()
  {
      const _this = this;      

      return ( 

            <React.Fragment>
                <center ref={this.confirmation_ref}>
                <h3>Thanks!</h3>
                <p>You will receive a confirmation email to confirm your appointment shortly.</p>
                
                </center>

                <div>
                {
                    _this.scroll_to_top()
                }
                </div>
            </React.Fragment>
      );
  }

  render_appointment_booker()
  {
    const _this = this;

    const {events, selected_time, confirmed_time} = _this.state;
    return (

      <React.Fragment>
        <Datetime 
                  open={true}
                  input={false}
                  timeFormat={false}
                  renderDay={_this.render_day}
                  renderMonth={_this.render_month}
                  renderYear={_this.render_year}
                  isValidDate={valid_date}
                  onChange={(moment_date)=>
                  {
                      const date_obj = moment_date._d;
                      const events_on_day = _this.find_events_on_day(date_obj.getDate(), date_obj.getMonth());
                      const day_data =
                      {
                        date: date_obj,
                        events: events_on_day
                      }

                      _this.setState({..._this.state, selected_day: day_data, selected_time: null});
                  }}
                  onOpen={(stuff)=>
                  {
                      console.log("stuff: ", stuff);
                  }}/>
      </React.Fragment>
    );
  }


  render_google_calendar_connect_button()
  {
    const _this = this;

    return (
      <button onClick={_this.handle_click}>
        Connect Google Calendar
      </button>
    );
  }

  render_calendar()
  {
    const _this = this;

    const {events, selected_time, confirmed_time} = _this.state;
    _this.scroll_to_top();

    if(events != null)
    {
      return (

        <React.Fragment>
          
          <Container >
          <Row ref={_this.top_ref} id="appointment-picker-react-center-col">
            <Col md={12}>
                {!confirmed_time && !selected_time && _this.render_appointment_booker()}            
              <div className="day_times_row_continer" style={{marginTop: 30}}>
                {!selected_time && !confirmed_time && _this.render_times()}
                {selected_time && !confirmed_time && _this.render_selected_time()}
                {confirmed_time && _this.render_confirmation()}
              </div>
            </Col>
          </Row>
          </Container>

        </React.Fragment>
      );
    }
  }

  render()
  {
    const _this = this;

    // return <h2>HAVE ATS: <br/> {have_connection ? "True" : "False"}</h2>

    const {mounted, have_connection} = _this.state;
    if(mounted)
    {
      if(have_connection == false)
      {
         return _this.render_google_calendar_connect_button();
      }
      else
      {
        return _this.render_calendar();
      }
    }
  }
};

export default GoogleCalendarAppointmentPicker;
